<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.SMS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS.DESC')"
    />
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <!--
        The `<label>` is a sibling with a `for`, not a wrapper. A wrapping label names the
        input it contains; the branded control renders a BUTTON, and a label cannot name a
        button — which is why the `label` prop is passed as well as rendered.
      -->
      <label for="sms-provider">
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
      </label>
      <woot-select
        id="sms-provider"
        v-model="provider"
        :options="providerOptions"
        :label="$t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL')"
      />
    </div>
    <twilio v-if="provider === 'twilio'" type="sms" />
    <bandwidth-sms v-else />
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio.vue';
import WootSelect from 'dashboard/components/ui/Select.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    BandwidthSms,
    WootSelect,
  },
  data() {
    return {
      provider: 'twilio',
    };
  },
  computed: {
    // Computed and not `data`, because `$t()` read once in `data()` freezes at the language
    // the screen first mounted in and this product switches language in place.
    //
    // Both values are STRINGS and stay strings: `provider` is what the two `v-if` branches
    // below compare against with `===`, and it is also the discriminator the Twilio wizard
    // reads. The second option keeps the value `360dialog` even though its label is the
    // Bandwidth one — that mismatch is pre-existing and inverting it here would silently
    // change which sub-form an existing choice opens.
    providerOptions() {
      return [
        {
          value: 'twilio',
          label: this.$t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO'),
        },
        {
          value: '360dialog',
          label: this.$t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH'),
        },
      ];
    },
  },
};
</script>
